import {Injectable, Injector} from '@angular/core';
import {
	HttpBackend,
	HttpClient,
	HttpParameterCodec,
} from '@angular/common/http';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {environment} from '@env/environment';
import {SnackBar} from '@app/core/services/snackbar.service';
import {TranslateService} from '@ngx-translate/core';

@Injectable()
export class HttpService {
	public tenantId: number;
	public responses: any = [];
	public urlApi: string;
	public urlApiAuth: string;
	public url: string;
	public shortUrl: string;
	public access_token: string;
	public pusherKey: string;
	private httpWithoutInterceptor: HttpClient;

	constructor(private injector: Injector) {
		this.access_token = localStorage.getItem('access_token');
		let tenantId = parseInt(localStorage.getItem('tenantId'));
		if (isNaN(tenantId)) {
			tenantId = undefined;
		}
		this.setTenant(tenantId);
		this.httpWithoutInterceptor = new HttpClient(this.httpBackend);
	}

	public get router(): Router {
		return this.injector.get(Router);
	}

	public get httpBackend(): HttpBackend {
		return this.injector.get(HttpBackend);
	}

	public get http(): HttpClient {
		return this.injector.get(HttpClient);
	}

	public get snackBar(): SnackBar {
		return this.injector.get(SnackBar);
	}

	public get translate(): TranslateService {
		return this.injector.get(TranslateService);
	}

	public setTenant(id: number): void {
		this.tenantId = id;
		localStorage.setItem('tenantId', this.tenantId + '');
		this.setUrls();
	}

	public setUrls(): void {
		this.url = environment.baseApiUrl;
		this.shortUrl = this.url.substr(0, this.url.length - 4);
		this.pusherKey = environment.pusherKey;
		this.urlApi = this.url + this.tenantId + '/';
		this.urlApiAuth = this.url + this.tenantId + '/auth/';
	}

	public authPostJson<T>(url, payload): Observable<T> {
		return this.http.post<T>(this.urlApiAuth + url, payload);
	}

	public getExternalUrlJson<T>(url, payload = {}): Observable<any> {
		return this.http.get<T>(url, {params: payload});
	}

	public postExternalUrlJson<T>(url, payload = {}): Observable<any> {
		return this.http.post<T>(url, payload);
	}

	public setExtraRavenContext(url, res, step = 0): void {
		if (environment.production) {
			if (this.responses.length > 10) {
				this.responses.splice(0, 1);
			}
			this.responses.push({url, res, step});
		}
	}

	public putExternal<T>(url, payload): Observable<T> {
		return this.httpWithoutInterceptor.put<T>(url, payload);
	}

	public postJson<T>(url, payload): Observable<T> {
		return this.http.post<T>(this.urlApi + url, payload);
	}

	public patchJson<T>(url, payload): Observable<T> {
		return this.http.patch<T>(this.urlApi + url, payload);
	}

	public deleteJson<T>(url, payload?): Observable<T> {
		if (!payload) {
			payload = {};
		}

		return this.http.request<T>('delete', this.urlApi + url, {body: payload});
	}

	public getJson<T>(url: string, payload: any = {}): Observable<any> {
		if (!payload) {
			payload = {};
		}

		return this.http.get<T>(this.urlApi + url, {params: payload});
	}
}

export class CustomEncoder implements HttpParameterCodec {
	public encodeKey(key: string): string {
		return encodeURIComponent(key);
	}

	public encodeValue(value: string): string {
		return encodeURIComponent(value);
	}

	public decodeKey(key: string): string {
		return decodeURIComponent(key);
	}

	public decodeValue(value: string): string {
		return decodeURIComponent(value);
	}
}
